import type { FaireProductEntity } from "../../entity_types/product";

export const p_17k3v1jd0d: FaireProductEntity = {
  token: "p_17k3v1jd0d",
  type: "product",
  name: "Huggies - Fire Opal - Earrings",
  brandToken: "b_f0fbd5c7",
  brandName: "JaxKelly",
  imageUrl:
    "https://cdn.faire.com/fastly/2ae6b5d6c71859c8ab6b5366fc8812d24c70a2c9eb2483ff16931637ec85e364.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2dcd5c0c671ca4c99da5b91da6441d50b54dfd966f4003316c1739b847707b7.jpeg",
    "https://cdn.faire.com/fastly/4e4f966dadab474cda86b55ecbac75d900e19b29ad4e6bcd1828d63fa6d5db4e.jpeg",
    "https://cdn.faire.com/fastly/f507f766df33cbaf5e9b3caa726fa7d1b61d6e7a47982ec795287f2720e59493.jpeg",
    "https://cdn.faire.com/fastly/8a92663920417633e5d70b30eb7a16f70f5aa7515b5bae225dab6898d5211436.png",
    "https://cdn.faire.com/fastly/935d05909b203b49ef2394da4581a825d25f0c8b298ee3c7dfc7a5af6a49bbb5.jpeg",
  ],
  priceDollars: 17.3,
  description:
    "These Huggies feature a gemstone that hugs tight to your ear.\n\nLoop the non-stone end through like you would a regular post, and let the stone sit against your ear.\n\n• Tarnish Free - Long lasting protective coating safeguarding your jewelry from sweat, water, and more.\n• Sterling Silver – 18K gold plating over silver\n• Hypoallergenic – Lead Free\n• Lab Grown Fire Opal\n• Outer Diameter 11mm",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:09.342Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
